import './Login.scss';

interface Props {
  activeStep: number;
}

function IconPeople() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="7" r="3" />
      <circle cx="17" cy="7" r="2.5" />
      <path d="M3 21v-1a5 5 0 0 1 5-5h2" />
      <path d="M14 21v-1a4 4 0 0 1 4-4v0a4 4 0 0 1 4 4v1" />
    </svg>
  );
}

function IconLogin() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
      <polyline points="10 17 15 12 10 7" />
      <line x1="15" y1="12" x2="3" y2="12" />
    </svg>
  );
}

function IconAgree() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="9" y1="13" x2="15" y2="13" />
      <line x1="9" y1="17" x2="13" y2="17" />
    </svg>
  );
}

function IconInfo() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}

function IconComplete() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <polyline points="9 12 11 14 15 10" />
    </svg>
  );
}

const STEPS: { label: string; Icon: () => JSX.Element }[] = [
  { label: '유형선택', Icon: IconPeople },
  { label: '간편가입', Icon: IconLogin },
  { label: '동의', Icon: IconAgree },
  { label: '정보입력', Icon: IconInfo },
  { label: '가입완료', Icon: IconComplete },
];

export default function SignupStepper({ activeStep }: Props) {
  return (
    <div className="lp__stepper" aria-label="회원가입 단계">
      {STEPS.map(({ label, Icon }, i) => {
        const n = i + 1;
        const modifier =
          n === activeStep ? 'lp__step--active'
          : n < activeStep ? 'lp__step--complete'
          : '';
        return (
          <div key={n} className="lp__stepper-item">
            {i > 0 && <div className="lp__step-sep" aria-hidden="true">›</div>}
            <div className={`lp__step ${modifier}`}>
              <div className="lp__step-bullet">
                <Icon />
              </div>
              <div className="lp__step-label">
                <strong>{label}</strong>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
